import { Routes } from '@angular/router';
import { ConversationList } from './components/conversation-list/conversation-list';
import { ConversationMessages } from './components/conversation-messages/conversation-messages';
import { Login } from './components/login/login';
import { AuthGuard } from './guards/auth-guard';
import { Dashboard } from './components/dashboard/dashboard';
import { Settings } from './components/settings/settings';
import { InsightsComponent } from './components/business-intelligence/insights/insights.component';

export const routes: Routes = [
    { path: 'login', component: Login },
    { path: '', component: Dashboard, canActivate: [AuthGuard] }, // Default route
    { path: 'dashboard', component:Dashboard , canActivate: [AuthGuard] }, // Default route
    { path: 'conversation', component: ConversationList, canActivate: [AuthGuard] }, 
    { path: 'conversation/:id', component: ConversationMessages, canActivate: [AuthGuard] },
    { path: 'settings', component: Settings, canActivate: [AuthGuard] }, 
    { path: 'insights', component:InsightsComponent , canActivate: [AuthGuard] }, // Default route



  { path: '**', redirectTo: '/login' } // Wildcard redirects to home
];
